export default function RoleOptionCard({
  img,
  title,
  value,
  isSelected,
  onSelect,
  dataTestId,
}) {
  return (
    <div
      onClick={() => onSelect(value)}
      className={`h-auto text-white flex flex-col items-center justify-center p-6 w-32 md:w-56 border-2 rounded-xl cursor-pointer space-y-3 transition-colors
        ${
          isSelected
            ? "bg-brand/80 border-brand backdrop-blur-xs"
            : "bg-white/10 border-white/20 backdrop-blur-xs hover:bg-brand/30 hover:scale-105 transition-transform duration-200"
        }
      `}
      data-testid={dataTestId}
    >
      <div className="flex flex-col items-center text-center space-y-4">
        <img
          src={img}
          alt={title}
          className="w-16 h-16 object-contain"
        />
        <h4>{title}</h4>
      </div>
    </div>
  );
}
